import React from 'react';
import whatsapp from "../assets/socialmedia/whatsapp.png";


export const Newletter = () => {


	const description = ""

	return (

		<section id='newsletter'>
			<div className='text-card-container'>
				<h1 className='section-header'>Newsletter</h1>


				<div className="row">
					<div className="col">
						<p>Komm gerne in meine <a
							className='nav-bar-link nav-icon'
							href="https://chat.whatsapp.com/DtyE8wIgyBWCxCnjTLbdy2?s=cl&p=i&mlu=1"
							rel="noreferrer"
							target="_blank"
							style={{ display: 'inline-block', textAlign: 'left' }}
						>WhatsApp-Gruppe</a>, um neue Termine mitzubekommen.</p>
						<br />
						<br />
						<a
							className='nav-bar-link nav-icon'
							href="https://chat.whatsapp.com/DtyE8wIgyBWCxCnjTLbdy2?s=cl&p=i&mlu=1"
							rel="noreferrer"
							target="_blank"
							style={{ display: 'inline-block', textAlign: 'left' }}
						>
							<img width="100" height="100" className='whatsapp' src={whatsapp} alt="whatsapp" />
						</a>

					</div>
				</div>


			</div>
		</section>

	);
}